import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IInventoryCounter } from '../models';
import {
  MyHttpClientFactory,
  ResponseCasingEnum,
  environment,
} from '@ups/xplat/core';
import { Observable, tap } from 'rxjs';

const COUNTER_ENDPOINT = `/api/InventoryCounter`;

const GET_INVENTORY_COUNTERS = (inventoryCountId: string) =>
  `${COUNTER_ENDPOINT}/${inventoryCountId}`;

const REMOVE_INVENTORY_COUNTER_ENDPOINT = (
  inventoryCountId: string,
  employeeId: string
) => `${COUNTER_ENDPOINT}/${inventoryCountId}/${employeeId}`;

@Injectable({
  providedIn: 'root',
})
export class InventoryCounterService {
  protected toolTrackerBaseUrl: string;
  protected httpToolTracker: HttpClient;

  constructor(httpClientFactory: MyHttpClientFactory) {
    this.toolTrackerBaseUrl = environment.urls.toolTrackerAPI;
    this.httpToolTracker = httpClientFactory.createHttpClient(
      this.toolTrackerBaseUrl,
      true,
      ResponseCasingEnum.CamelCase
    );
  }

  getInventoryCounterList(
    inventoryCountId: string
  ): Observable<IInventoryCounter[]> {
    return this.httpToolTracker.get<IInventoryCounter[]>(
      GET_INVENTORY_COUNTERS(inventoryCountId)
    );
  }

  addInventoryCounter(body: IInventoryCounter) {
    return this.httpToolTracker.post<IInventoryCounter>(COUNTER_ENDPOINT, body);
  }

  addInventoryCounters(body: IInventoryCounter[]) {
    return this.httpToolTracker.post<IInventoryCounter>(
      `${COUNTER_ENDPOINT}/list`,
      body
    );
  }

  deleteInventoryCounter(inventoryCountId: string, employeeId: string) {
    const url = REMOVE_INVENTORY_COUNTER_ENDPOINT(inventoryCountId, employeeId);

    return this.httpToolTracker.delete<IInventoryCounter>(url);
  }
}
